import { Image, LI, UL } from "../../AbstractElements";
import { Href } from "../../Constant";
import { dynamicImage } from "../../Service/DynamicImage";
import { ScrollVerticalType } from "../../Type/DataTable";

export const SCROLL_VERTICAL_DATA = [
  {
    name: "user/1.jpg",
    title: "Zorita Serrano",
    position: "Software Engineer",
    office: "San Francisco",
    age: "56",
    startDate: "2012/06/01",
    salery: "$115,000",
    action: "ts-1",
  },
  {
    name: "user/12.png",
    title: "Zenaida Frank",
    position: "Software Engineer",
    office: "New York",
    age: "63",
    startDate: "2010/01/04",
    salery: "$125,250",
    action: "ts-2",
  },
  {
    name: "user/2.jpg",
    title: "Yuri Berry",
    position: "Chief Marketing Officer (CMO)",
    office: "New York",
    age: "40",
    startDate: "2009/06/25",
    salery: "$675,000",
    action: "ts-3",
  },
  {
    name: "user/2.jpg",
    title: "Vivian Harrell",
    position: "Financial Controller",
    office: "San Francisco",
    age: "62",
    startDate: "2009/02/14",
    salery: "$452,500",
    action: "ts-4",
  },
  {
    name: "user/12.png",
    title: "Unity Butler",
    position: "Marketing Designer",
    office: "San Francisco",
    age: "47",
    startDate: "2009/12/09",
    salery: "$85,675",
    action: "ts-5",
  },
  {
    name: "user/12.png",
    title: "Timothy Mooney",
    position: "Office Manager",
    office: "London",
    age: "37",
    startDate: "2008/12/11",
    salery: "$136,200",
    action: "ts-6",
  },
  {
    name: "user/1.jpg",
    title: "Tiger Nixon",
    position: "System Architect",
    office: "Edinburgh",
    age: "61",
    startDate: "2011/04/25",
    salery: "$320,800",
    action: "ts-7",
  },
  {
    name: "user/1.jpg",
    title: "Thor Walton",
    position: "Developer",
    office: "New York",
    age: "61",
    startDate: "2013/08/11",
    salery: "$98,540",
    action: "ts-8",
  },
  {
    name: "user/2.jpg",
    title: "Tatyana Fitzpatrick",
    position: "Regional Director",
    office: "London",
    age: "19",
    startDate: "2010/03/17",
    salery: "$385,750",
    action: "ts-9",
  },
  {
    name: "user/12.png",
    title: "Suki Burks",
    position: "Developer",
    office: "London",
    age: "53",
    startDate: "2009/10/22",
    salery: "$114,500",
    action: "ts-10",
  },
  {
    name: "user/2.png",
    title: "Sonya Frost",
    position: "Software Engineer",
    office: "Edinburgh",
    age: "23",
    startDate: "2008/12/13",
    salery: "$103,600",
    action: "ts-11",
  },
  {
    name: "user/2.png",
    title: "Shou Itou",
    position: "Regional Marketing",
    office: "Tokyo",
    age: "20",
    startDate: "2011/08/14",
    salery: "$163,000",
    action: "ts-12",
  },
  {
    name: "user/2.jpg",
    title: "Shad Decker",
    position: "Regional Director",
    office: "Edinburgh",
    age: "51",
    startDate: "2008/11/13",
    salery: "$183,000",
    action: "ts-13",
  },
  {
    name: "user/2.jpg",
    title: "Serge Baldwin",
    position: "Data Coordinator",
    office: "Singapore",
    age: "64",
    startDate: "2012/04/09",
    salery: "$138,575",
    action: "ts-14",
  },
  {
    name: "user/12.png",
    title: "Sakura Yamamoto",
    position: "Support Engineer",
    office: "Tokyo",
    age: "37",
    startDate: "2009/08/19",
    salery: "$139,575",
    action: "ts-15",
  },
  {
    name: "user/12.png",
    title: "Rhona Davidson",
    position: "Integration Specialist",
    office: "Tokyo",
    age: "55",
    startDate: "2010/10/14",
    salery: "$327,900",
    action: "ts-16",
  },
  {
    name: "user/12.png",
    title: "Quinn Flynn",
    position: "Support Lead",
    office: "Edinburgh",
    age: "22",
    startDate: "2013/03/03",
    salery: "$342,000",
    action: "ts-17",
  },
  {
    name: "user/1.jpg",
    title: "Prescott Bartlett",
    position: "Technical Author",
    office: "London",
    age: "27",
    startDate: "2011/05/07",
    salery: "$145,000",
    action: "ts-18",
  },
  {
    name: "user/1.jpg",
    title: "Paul Byrd",
    position: "Chief Financial Officer (CFO)",
    office: "New York",
    age: "64",
    startDate: "2010/06/09",
    salery: "$725,000",
    action: "ts-19",
  },
  {
    name: "user/2.jpg",
    title: "Olivia Liang",
    position: "Support Engineer",
    office: "Singapore",
    age: "64",
    startDate: "2011/02/03",
    salery: "$234,500",
    action: "ts-20",
  },
  {
    name: "user/2.jpg",
    title: "Michelle House",
    position: "Integration Specialist",
    office: "Sidney",
    age: "37",
    startDate: "2011/06/02",
    salery: "$95,400",
    action: "ts-21",
  },
  {
    name: "user/12.png",
    title: "Michael Silva",
    position: "Marketing Designer",
    office: "London",
    age: "66",
    startDate: "2012/11/27",
    salery: "$198,500",
    action: "ts-22",
  },
  {
    name: "user/12.png",
    title: "Michael Bruce",
    position: "Javascript Developer",
    office: "Singapore",
    age: "29",
    startDate: "2011/06/27",
    salery: "$183,000",
    action: "ts-23",
  },
  {
    name: "user/2.jpg",
    title: "Martena Mccray",
    position: "Post-Sales support",
    office: "Edinburgh",
    age: "46",
    startDate: "2011/03/09",
    salery: "$324,050",
    action: "ts-24",
  },
  {
    name: "user/1.jpg",
    title: "Lael Greer",
    position: "Systems Administrator",
    office: "London",
    age: "21",
    startDate: "2009/02/27",
    salery: "$103,500",
    action: "ts-25",
  },
  {
    name: "user/2.png",
    title: "Jonas Alexander",
    position: "Developer",
    office: "San Francisco",
    age: "30",
    startDate: "2010/07/14",
    salery: "$86,500",
    action: "ts-26",
  },
  {
    name: "user/2.jpg",
    title: "Jennifer Chang",
    position: "Regional Director",
    office: "Singapore",
    age: "28",
    startDate: "2010/11/14",
    salery: "$357,650",
    action: "ts-27",
  },
  {
    name: "user/2.png",
    title: "Jennifer Acosta",
    position: "Junior Javascript Developer",
    office: "Edinburgh",
    age: "43",
    startDate: "2013/02/01",
    salery: "$75,650",
    action: "ts-28",
  },
  {
    name: "user/2.jpg",
    title: "Jenette Caldwell",
    position: "Development Lead",
    office: "New York",
    age: "30",
    startDate: "2011/09/03",
    salery: "$345,000",
    action: "ts-29",
  },
  {
    name: "user/2.jpg",
    title: "Jena Gaines",
    position: "Office Manager",
    office: "London",
    age: "30",
    startDate: "2008/12/19",
    salery: "$90,560",
    action: "ts-30",
  },
  {
    name: "user/1.jpg",
    title: "Jackson Bradshaw",
    position: "Director",
    office: "New York",
    age: "65",
    startDate: "2008/09/26",
    salery: "$645,750",
    action: "ts-31",
  },
  {
    name: "user/1.jpg",
    title: "Howard Hatfield",
    position: "Office Manager",
    office: "San Francisco",
    age: "51",
    startDate: "2008/12/16",
    salery: "$164,500",
    action: "ts-32",
  },
  {
    name: "user/2.png",
    title: "Hope Fuentes",
    position: "Secretary",
    office: "San Francisco",
    age: "41",
    startDate: "2010/02/12",
    salery: "$109,850",
    action: "ts-33",
  },
  {
    name: "user/2.png",
    title: "Herrod Chandler",
    position: "Sales Assistant",
    office: "San Francisco",
    age: "59",
    startDate: "2012/08/06",
    salery: "$137,500",
    action: "ts-34",
  },
  {
    name: "user/12.png",
    title: "Hermione Butler",
    position: "Regional Director",
    office: "London",
    age: "47",
    startDate: "2011/03/21",
    salery: "$356,250",
    action: "ts-35",
  },
  {
    name: "user/2.png",
    title: "Haley Kennedy",
    position: "Senior Marketing Designer",
    office: "London",
    age: "43",
    startDate: "2012/12/18",
    salery: "$313,500",
    action: "ts-36",
  },
  {
    name: "user/2.png",
    title: " Gloria Little",
    position: "Systems Administrator",
    office: "New York",
    age: "59",
    startDate: "2009/04/10",
    salery: "$237,500",
    action: "ts-37",
  },
  {
    name: "user/2.png",
    title: "Gavin Joyce",
    position: "Developer",
    office: "Edinburgh",
    age: "42",
    startDate: "2010/12/22",
    salery: "$92,575",
    action: "ts-38",
  },
  {
    name: "user/2.png",
    title: "Gavin Cortez",
    position: "Team Leader",
    office: "San Francisco",
    age: "22",
    startDate: "2008/10/26",
    salery: "$235,500",
    action: "ts-39",
  },
  {
    name: "user/2.png",
    title: "Garrett Winters",
    position: "Accountant",
    office: "Tokyo",
    age: "63",
    startDate: "2011/07/25",
    salery: "$170,750",
    action: "ts-40",
  },
  {
    name: "user/1.jpg",
    title: " Fiona Green",
    position: "Chief Operating Officer (COO)",
    office: "San Francisco",
    age: "48",
    startDate: "2010/03/11",
    salery: "$850,000",
    action: "ts-41",
  },
  {
    name: "user/2.png",
    title: "Finn Camacho",
    position: "Support Engineer",
    office: "San Francisco",
    age: "47",
    startDate: "2009/07/07",
    salery: "$87,500",
    action: "ts-42",
  },
  {
    name: "user/1.jpg",
    title: "Doris Wilder",
    position: "Sales Assistant",
    office: "Sidney",
    age: "23",
    startDate: "2010/09/20",
    salery: "$85,600",
    action: "ts-43",
  },
  {
    name: "user/2.png",
    title: "Donna Snider",
    position: "Customer Support",
    office: "New York",
    age: "27",
    startDate: "2011/01/25",
    salery: "$112,000",
    action: "ts-44",
  },
  {
    name: "user/12.png",
    title: "Dai Rios",
    position: "Personnel Lead",
    office: "Edinburgh",
    age: "35",
    startDate: "2012/09/26",
    salery: "$217,500",
    action: "ts-45",
  },
  {
    name: "user/1.jpg",
    title: "Colleen Hurst",
    position: "Javascript Developer",
    office: "San Francisco",
    age: "39",
    startDate: "2009/09/15",
    salery: "$205,500",
    action: "ts-46",
  },
  {
    name: "user/1.jpg",
    title: "Charde Marshall",
    position: "Regional Director",
    office: "San Francisco",
    age: "36",
    startDate: "2008/10/16",
    salery: "$470,600",
    action: "ts-47",
  },
  {
    name: "user/12.png",
    title: "Cedric Kelly",
    position: "Senior Javascript Developer",
    office: "Edinburgh",
    age: "22",
    startDate: "2012/03/29",
    salery: "$433,060",
    action: "ts-48",
  },
  {
    name: "user/2.jpg",
    title: "Cara Stevens",
    position: "Sales Assistant",
    office: "New York",
    age: "46",
    startDate: "2011/12/06",
    salery: "$145,600",
    action: "ts-49",
  },
  {
    name: "user/12.png",
    title: "Caesar Vance",
    position: "Pre-Sales Support",
    office: "New York",
    age: "21",
    startDate: "2011/12/12",
    salery: "$106,450",
    action: "ts-50",
  },
  {
    name: "user/2.png",
    title: "Bruno Nash",
    position: "Software Engineer",
    office: "London",
    age: "38",
    startDate: "2011/05/03",
    salery: "$163,500",
    action: "ts-51",
  },
  {
    name: "user/2.png",
    title: "Brielle Williamson",
    position: "Integration Specialist",
    office: "New York",
    age: "61",
    startDate: "2012/12/02",
    salery: "$372,000",
    action: "ts-52",
  },
  {
    name: "user/12.png",
    title: "Brenden Wagner",
    position: "Software Engineer",
    office: "San Francisco",
    age: "28",
    startDate: "2011/06/07",
    salery: "$206,850",
    action: "ts-53",
  },
  {
    name: "user/2.jpg",
    title: "Bradley Greer",
    position: "Software Engineer",
    office: "London",
    age: "41",
    startDate: "2012/10/13",
    salery: "$132,000",
    action: "ts-54",
  },
  {
    name: "user/2.jpg",
    title: "Ashton Cox",
    position: "Junior Technical Author",
    office: "San Francisco",
    age: "66",
    startDate: "2009/01/12",
    salery: "$86,000",
    action: "ts-55",
  },
  {
    name: "user/2.png",
    title: "Angelica Ramos",
    position: "Chief Executive Officer (CEO)",
    office: "London",
    age: "47",
    startDate: "2009/10/09",
    salery: "$1,200,000",
    action: "ts-56",
  },
  {
    name: "user/1.jpg",
    title: "Airi Satou",
    position: "Accountant",
    office: "Tokyo",
    age: "33",
    startDate: "2008/11/28",
    salery: "$162,700",
    action: "ts-57",
  },
];

interface ScrollImagetype {
  image: string;
  title: string;
}

const ScrollImage = ({ image, title }: ScrollImagetype) => {
  return (
    <>
      <Image width="32" height="32" className="img-fluid table-avtar" src={dynamicImage(image)} alt="userImage" /> {title}
    </>
  );
};

interface TableActionType {
  id: string;
}

const TableActions = ({ id }: TableActionType) => {
  return (
    <UL className="action simple-list d-flex flex-row" id={id}>
      <LI className="edit">
        <a href={Href}>
          <i className="icon-pencil-alt" />
        </a>
      </LI>
      <LI className="delete">
        <a href={Href}>
          <i className="icon-trash" />
        </a>
      </LI>
    </UL>
  );
};

export const SCROLL_VERTICAL_COLUMN = [
  {
    name: "Name",
    cell: (row: ScrollVerticalType) => <ScrollImage image={row.name} title={row.title} />,
    sortable: true,
    center: false,
  },
  {
    name: "Position",
    selector: (row: ScrollVerticalType) => `${row.position}`,
    sortable: true,
    center: true,
  },
  {
    name: "office",
    selector: (row: ScrollVerticalType) => `${row.office}`,
    sortable: true,
    center: true,
  },
  {
    name: "Age",
    selector: (row: ScrollVerticalType) => `${row.age}`,
    sortable: true,
    center: true,
  },
  {
    name: "Start Date",
    selector: (row: ScrollVerticalType) => `${row.startDate}`,
    sortable: true,
    center: true,
  },
  {
    name: "Salery",
    selector: (row: ScrollVerticalType) => `${row.salery}`,
    sortable: true,
    center: true,
  },
  {
    name: "action",
    cell: (row: ScrollVerticalType) => <TableActions id={row.action} />,
    sortable: true,
    center: true,
  },
];
